import React from 'react';
import { Link } from 'react-router-dom';
import './OrbixOculo.css';

function OrbixOculo() {
  return (
    <section className="bg-secondary-v3">
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-11 col-md-11 col-lg-10 mx-auto text-center pt-4 pt-md-5 mt-2 mt-md-3 px-3 px-sm-0">
            <img src="/assets/img/logo/oculo_logo.png" alt="Icon" className="img-fluid" style={{ maxWidth: '200px', width: '100%', height: 'auto' }} />
            <h2 className="h3 mb-3 mb-md-4 mt-3 mt-md-4"> Go Digital Without Limits</h2>
            <p className="fs-lg mb-0">
            The industry's most accurate document intelligence engine. Oculo reads, extracts, and structures data from any document format, turning every report into a live digital record ready for AI validation, analytics, and operational insights.
            </p>
          </div>
        </div>
      
        <div className="pt-3 pt-md-3 pb-2 pb-md-3">
          <div className="row align-items-center my-3 py-md-3 mb-md-5">
            <div className="col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6 offset-sm-1 offset-md-0 order-md-1 mb-4 mb-md-0 pb-4 pb-md-0">
              <div className="position-relative mx-auto mx-md-0">
                <video src="/assets/home_page/v3/videos/orbix-oculo.mp4" className="oculo-video w-100" autoPlay loop playsInline muted></video>
              </div>
            </div>
            
            <div className="col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6 offset-sm-1 offset-md-0 order-md-2 pb-2 pb-md-4 ps-md-3 ps-lg-4 ps-xl-5">
              <ul className="list-unstyled pb-3 mb-3">
                <li className="d-flex align-items-center mb-2 mb-lg-3">
                  <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                  <span>Converts any report or legacy PDF into precise, structured digital data
                  </span>
                </li>
                <li className="d-flex align-items-center mb-2 mb-lg-3">
                  <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                  <span>Powers deep analytics, AI validation, and operational insights across every project
                  </span>
                </li>
                <li className="d-flex align-items-center mb-2 mb-lg-3">
                  <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                  <span>Capture valuable data from years of historical reports instantly
                  </span>
                </li>
                <li className="d-flex align-items-center mb-2 mb-lg-3">
                  <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                  <span>No workflow changes required
                  </span>
                </li>
               
              </ul>
              <Link className="qcta" to="/apps/oculo">Discover Oculo <span>&rarr;</span></Link>
            </div>
          </div>
      
          {/* Extra spacing for dark mode only */}
          <div className="pt-5 d-none d-dark-mode-block"></div>
        </div>
      </div>
    </section>
  );
}

export default OrbixOculo;

